import { Button, LoadingAnimation, Text } from '@/components'
import { Utility } from '@/types'
import { AlertMessage, Link } from 'app-components'
import TextFormField from '@/components/forms/text-form-field'
import { ButtonContainer } from '@/app/pages/ava/BrandedPage'
import useExternalNavigation from '@/app/hooks/useExternalNavigation'
import useViewModel, {
  AccountNumberEntryProps,
} from 'features/connect-utility/AccountNumberEntry/useViewModel'

function WebsiteLink({ utility }: { utility: Utility | null }) {
  const { externallyNavigate } = useExternalNavigation()

  if (!utility?.website) {
    return <>utility's website</>
  }

  return (
    <Link onClick={() => externallyNavigate(utility.website ?? '')}>
      utility's website
    </Link>
  )
}

export default function AccountNumberEntry(props: AccountNumberEntryProps) {
  const {
    isLoading,
    accountNumber,
    register,
    submit,
    skip,
    utility,
    formState,
    submissionErrors,
  } = useViewModel(props)

  if (isLoading) {
    return <LoadingAnimation type="falling" centered />
  }

  return (
    <>
      <div className="flex flex-col gap-2">
        <Text variant="h3">What's your account number?</Text>
        <Text variant="body2">
          You can find your account number on your most recent utility bill or
          by logging into your <WebsiteLink utility={utility ?? null} />
        </Text>
        {submissionErrors && (
          <AlertMessage variant="error">{submissionErrors}</AlertMessage>
        )}
        <div className="mt-2">
          <TextFormField
            label="Account Number"
            register={register}
            name="accountNumber"
            defaultValue={accountNumber}
          />
        </div>
      </div>
      <ButtonContainer>
        <Button id="skip-btn" onClick={skip} variant="secondary">
          Skip
        </Button>
        <Button
          id="submit-btn"
          disabled={!formState.isValid || formState.isSubmitting}
          onClick={submit}
        >
          Next
        </Button>
      </ButtonContainer>
    </>
  )
}
